/* @flow strict */

import * as React from 'react';
import PieBreakdown from './pieBreakdown';
import _ from 'lodash';
import { mockData } from './mock';

type PropsType = {
  ticketsRevenueStatistics: any,
  isNoStatistic: boolean
};

const EventPageDetailStatsBreakdown = ({ ticketsRevenueStatistics, isNoStatistic }: PropsType): React.Element<'div'> => {
  const data = [];
  const _data = (isNoStatistic && !_.size(ticketsRevenueStatistics)) ? mockData.BreakDown : ticketsRevenueStatistics;

  _data.map((item: any) => {
    data.push({
      name: item.ticket_name,
      value: (item.merchant_revenue - item.merchant_revenue_refund) / 100,
      currency: item.currency
    });
  });

  return (
    <div className="panel panel-default panel-chart">
      <div className="panel-heading">
        Revenue Breakdown
      </div>
      <PieBreakdown data={data} type={'Revenue'}/>
    </div>
  );
};

export default EventPageDetailStatsBreakdown;
